/* Autogenerated file. Do not edit manually. */

import type { BytesLike, JsonAbi } from 'fuels';

export const generationDate = 1728255070813;
// biome-ignore lint: Autogenerated file
export const abi: JsonAbi = {
  programType: 'predicate',
  specVersion: '1',
  encodingVersion: '1',
  concreteTypes: [
    {
      type: 'b256',
      concreteTypeId:
        '7c5ee1cecf5f8eacd1284feb5f0bf2bdea533a51e2f0c9aabe9236d335989f3b',
    },
    {
      type: 'bool',
      concreteTypeId:
        'b760f44fa5965c2474a3b471467a22c43185152129295af588b022ae50b50903',
    },
    {
      type: 'u64',
      concreteTypeId:
        '1506e6f44c1d6291cdf46395a8e573276a4fa79e8ace3fc891e092ef32d1b0a0',
    },
  ],
  metadataTypes: [],
  functions: [
    {
      inputs: [
        {
          name: 'witness_index',
          concreteTypeId:
            '1506e6f44c1d6291cdf46395a8e573276a4fa79e8ace3fc891e092ef32d1b0a0',
        },
      ],
      name: 'main',
      output:
        'b760f44fa5965c2474a3b471467a22c43185152129295af588b022ae50b50903',
      attributes: null,
    },
  ],
  loggedTypes: [],
  messagesTypes: [],
  configurables: [
    {
      name: 'SIGNER',
      concreteTypeId:
        '7c5ee1cecf5f8eacd1284feb5f0bf2bdea533a51e2f0c9aabe9236d335989f3b',
      offset: 88,
    },
  ],
};
export const bin: BytesLike = new Uint8Array([
  26, 64, 48, 0, 80, 65, 0, 48, 26, 68, 80, 0, 186, 73, 0, 0, 50, 64, 4, 129,
  80, 65, 0, 32, 93, 73, 0, 0, 80, 65, 0, 8, 50, 64, 4, 130, 32, 69, 19, 0, 82,
  69, 16, 4, 74, 68, 0, 0, 58, 197, 196, 70, 242, 249, 157, 131, 208, 226, 220,
  119, 59, 183, 124, 97, 151, 131, 241, 56, 156, 77, 1, 152, 187, 169, 180, 134,
  128, 184, 1, 119, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 48, 49, 50, 51,
  52, 53, 54, 55, 56, 57, 97, 98, 99, 100, 101, 102, 204, 204, 204, 204, 204,
  204, 0, 2, 0, 0, 0, 0, 0, 0, 3, 48,
]);
